module.exports = __webpack_public_path__ + "img/xmgk.5113f6b3.png";